import React from 'react'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import WatchPositionComponent from './WatchPositionComponent'

const WatchPosition = ({ watchLocation }) =>
  watchLocation ? <WatchPositionComponent /> : null

WatchPosition.propTypes = {
  watchLocation: bool.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  watchLocation: spi.watchLocation,
})

export default connect(mapStateToProps)(WatchPosition)



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/WatchPosition/index.jsx